<template>
  <div class="list-wrap">

    <el-row class="list-table-wrap">
      <el-row v-show="listData.tableTopCon" class="list-table-top">

        <el-col class="list-table-top-wrap" :span="5">
          <el-dropdown size="mini">
            <span class="el-dropdown-link">
              {{searchTypeLable}}<i class="el-icon-arrow-down el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item,index) in searchTypeOptions" :key="item.value" @click.native="searchTypeChange(item.value)">{{item.lable}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-input class="list-table-top-orderId" v-model="searchTypeInp" :placeholder="searchTypeInpPh"></el-input>
        </el-col>

        <el-col class="list-table-top-wrap" :span="9">
          下单时间：
          <el-date-picker v-model="searchTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false">
          </el-date-picker>
        </el-col>
        <el-col class="list-table-top-wrap" :span="10">
          <el-button class="list-table-top-btn-clear" @click="clear">清空条件</el-button>
          <el-button type="primary" round @click="search">搜索</el-button>
          <el-button class="btn-isexport" round @click="exportList">导出</el-button>
          <el-button class="list-table-top-btn-clear list-table-top-btn-refresh" @click="search"><i class="el-icon-refresh-right"></i></el-button>
        </el-col>

      </el-row>
      <el-row class="list-table-con" ref="listTableCon">
        <!--  树结构参数 :tree-props="{children: 'children', hasChildren: 'hasChildren'}" :expand-row-keys="expands" -->
        <el-table v-loading="tableLoading" ref="multipleTable" lazy :data="listData.data" tooltip-effect="dark" :highlight-current-row="false" empty-text="暂无数据哦～" style="width: 100%" :row-class-name="tableRowClassName" row-key="id" :expand-row-keys="expands" :tree-props="{children: 'children', hasChildren: 'hasChildren'}" @selection-change=" handleSelectionChange" @sort-change="orderSort">
          <el-table-column v-if="showSelect" class-name="select-th-for-index" type="selection" width="50"></el-table-column>
          <el-table-column prop="order_id" sortable='custom' label="订单编号" width="180"></el-table-column>
          <el-table-column prop="username" label="客户昵称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="order_type" label="订单类型" width="80"></el-table-column>
          <el-table-column prop="buy_time" sortable='custom' label="下单时间" width="140"></el-table-column>
          <el-table-column class="goods-name-td" label="商品名称" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.productname}}<i v-if="scope.row.child_product.length>1" class="el-icon-more"></i>
            </template>
          </el-table-column>
          <el-table-column prop="product_num" sortable='custom' label="商品数量" width="100"></el-table-column>
          <el-table-column prop="orderprice" sortable='custom' label="订单金额" width="100">
            <template slot-scope="scope">
              ￥{{scope.row.orderprice}}
            </template>
          </el-table-column>
          <el-table-column class-name="order-table-trueproce-wrap" prop="trueprice" sortable='custom' label="支付金额" width="100">
            <template slot-scope="scope">
              <span class="order-table-trueproce-con">￥{{scope.row.trueprice}}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <span :class="getOrderStatusClass(scope.row)">{{scope.row.order_status}}</span>
            </template>
          </el-table-column>
          <el-table-column class-name="order-table-btns-wrap" header-align="center" align="left" label="操作" width="145">
            <template slot-scope="scope">
              <el-button v-if="rolesApi.indexOf('api_orders_order_property')>=0" class="table-attr-btn" size="mini" @click="handleAttr(scope.row)">属性</el-button>
              <el-button v-if="rolesApi.indexOf('api_orders_find_orders_by_id')>=0" size="mini" type="primary" @click="handleDetial(scope.row)">详情</el-button>

              <i v-if="scope.row.child_product.length>1" class="el-icon-caret-top" @click="openLine(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination :key="updataPage" v-if="page.total" :page-count="page.count" :current-page="page.current_page" :total-page="page.total_pages" :page-size="page.perPage" :total="page.total" background layout="prev, pager, next, total" @current-change="handleCurrentChange">
        </el-pagination>

      </el-row>
    </el-row>
    <!-- 弹窗 -->
    <popAttr v-if="showPopAttr" :showPopAttr="showPopAttr" :attrData="attrData" :param="param" @popAttrfn="popAttrfn"></popAttr>
    <popDetail v-if="showPopDetail" :showPopDetail="showPopDetail" :detailData="detailData" :param="param" :key="updataChild" @popDetailfn="popDetailfn"></popDetail>
  </div>
</template>

<script>
import popAttr from "@/components/popover/popAttr.vue";
import popDetail from "@/components/popover/popDetail.vue";
export default {
  props: ["dataList", "pagination", "searchParams", "showSelect"],
  data () {
    return {
      //多选等
      multipleSelection: [],
      // 子项颜色
      childBgColor: '',

      //筛选
      search_type: 0,
      searchTypeLable: "订单编号",
      searchTypeInp: "",
      searchTypeInpPh: "请输入订单编号",
      searchTypeOptions: [
        {
          lable: "订单编号",
          value: 0
        },
        {
          lable: "客户昵称",
          value: 1
        },
        {
          lable: "手机号码",
          value: 2
        }
      ],
      searchTime: "",
      time_start: "",
      time_end: "",
      //筛选的导出
      is_export: "0",

      updataChild: "",

      expands: [],
      showPopAttr: false,
      showPopDetail: false,
      orderIdPopDetail: "",

      status: "",
      order_type: 0,
      sort_order: "desc",

      listData: this.dataList,
      //订单详情和属性请求参数，
      param: {},
      attrData: {},
      detailData: {},
      pages: {
        page: 1,
        totalPage: 0,
        total: 0
      },
      updataPage: "",
      // 页码接收容器
      page: this.pagination
    };
  },
  created () {
    //初始化父组件传过来的列表数据
    this.listData.data.forEach(function (item) {
      item.children = item.child_product;
      item.productname = item.child_product.length > 0 ? item.child_product[0].productname : '';
      // 处理展开子项
      item.child_product.forEach(function (citem, cindex) {
        citem.id = `00${item.id}${cindex}`;
        // citem.order_id = citem.order_id;
        citem.child_product = [];
        citem.order_status = '';
        citem.order_type = item.order_type;
        // citem.productname = citem.productname;
        citem.orderprice = citem.price;
        citem.product_num = citem.number;
        citem.trueprice = item.trueprice;
        citem.type = item.type;
        citem.username = item.username;
        citem.created_at = item.created_at;
        citem.buy_time = item.buy_time;
      })
    })
  },
  watch: {
    searchTime () {
      if (this.searchTime != '') {
        let time = this.searchTime;
        this.time_start = this.ut.formatTime(time[0], "int");
        this.time_end = this.ut.formatTime(time[1], "int");
      }
    },
    updataOrderList () {
      if (this.updataOrderList) {
        // 获取到返回列表，更新列表
        this.search();
      }
    }

  },
  computed: {
    tableLoading: {
      get: function () {
        return this.$store.state.tableLoading;
      },
      set: function () { }
    },
    rolesApi: {
      get: function () {
        return this.$store.state.rolesApi;
      },
      set: function () { }
    },
    updataOrderList: {
      get: function () {
        return this.$store.state.updataOrderList;
      },
      set: function () { }
    }
  },
  mounted () {
  },
  methods: {
    openLine (row) {
      // 展开table中的行,子项数据需要后台数据格式更改,现在是自己改数据的
      this.$refs.multipleTable.toggleRowExpansion(row);
      event.target.className = (event.target.className == 'el-icon-caret-top active' ? 'el-icon-caret-top' : 'el-icon-caret-top active');
      // 点击展开勾选父子项
      this.$refs.multipleTable.toggleRowSelection(row);

      // 赋颜色等于总订单的背景色, 待优化
      // let nowTr = event.target.parentNode.parentNode.parentNode;
      // let childTr = document.querySelectorAll('.el-table__row--level-1');
      // if (nowTr.className.indexOf('row-white') >= 0) {
      //   childTr.forEach((item) => {
      //     item.className = item.className.replace(/row-white|row-grey/g, `row-white`);
      //   })
      // } else {
      //   childTr.forEach((item) => {
      //     item.className = item.className.replace(/row-white|row-grey/g, `row-grey`);
      //   })
      // }
    },
    getRowId (row) {
      return row.id;
    },

    // 属性弹框
    handleAttr (row) {
      let orderAttr = {
        type: row.type,
        order_id: row.order_id
      };
      this.param = orderAttr;
      this.getPopAttrData(orderAttr);
    },
    popAttrfn (data) {
      this.showPopAttr = data;
    },
    getPopAttrData (a) {
      this.$store.dispatch("setTableLoading", true);
      this.$axios
        .get("/api/v1/get/order/property", {
          params: a
        })
        .then(res => {
          if (res.data.status == "200") {
            this.attrData = res.data.data;
            this.showPopAttr = !this.showPopAttr;
          } else {
            this.$popup(res.data.msg, "error");
          }
          this.$store.dispatch("setTableLoading", false);
        });
    },

    //详情弹框
    handleDetial (row) {
      let orderDetail = {
        type: row.type,
        order_id: row.order_id
      };
      this.param = orderDetail;

      this.getPopDetailData(orderDetail);
    },
    popDetailfn (data) {
      this.showPopDetail = data;
    },
    getPopDetailData (a) {
      this.$store.dispatch("setTableLoading", true);
      this.$axios
        .get("/api/v1/order/detail", {
          params: a
        })
        .then(res => {
          if (res.data.status == "200") {
            // 处理商品单价
            let resData = res.data.data;
            this.detailData = resData;
            let resDataChild = this.detailData.childproduct.data;
            if (resDataChild.length > 0) {
              resDataChild.forEach((item) => {
                if (parseFloat(item.skuPrice) != 0) {
                  item.uPrice = parseFloat(item.skuPrice).toFixed(2)
                } else {
                  item.uPrice = '0.00'
                }
              })
            }

            this.showPopDetail = !this.showPopDetail;
            //更新子组件
            this.updataChild = new Date().getTime();
          } else {
            this.$popup(res.data.msg, "error");
          }
          this.$store.dispatch("setTableLoading", false);
        });
    },
    //页码切换
    handleCurrentChange (page) {
      let searchParam = {
        type: this.searchParams.type,
        status: this.searchParams.status,
        search_type: this.search_type,
        start_time: this.time_start,
        end_time: this.time_end,
        order_type: this.order_type,
        sort_order: this.sort_order,
        is_Excel: this.is_export,
        page: page
      };
      if (this.searchParams.type == "00") {
        delete searchParam.type;
      }
      if (!this.time_start || !this.time_end) {
        delete searchParam.start_time;
        delete searchParam.end_time;
      }
      if (this.searchTypeInp != "") {
        searchParam.search_value = this.searchTypeInp;
      }
      this.pages.page = page;
      this.getlist(searchParam);
    },
    clear () {
      //清空参数
      this.searchTypeInp = "";
      this.searchTime = "";
      this.time_start = "";
      this.time_end = "";
    },
    searchTypeChange (val) {
      this.search_type = val;
      if (val == 0) {
        this.searchTypeLable = "订单编号";
        this.searchTypeInpPh = "请输入订单编号";
      } else if (val == 1) {
        this.searchTypeLable = "客户昵称";
        this.searchTypeInpPh = "请输入客户昵称";
      } else {
        this.searchTypeLable = "手机号码";
        this.searchTypeInpPh = "请输入手机号码";
      }
    },
    search () {
      let searchParam = {
        page: 1,
        type: this.searchParams.type,
        status: this.searchParams.status,
        search_type: this.search_type,
        start_time: this.time_start,
        end_time: this.time_end,
        order_type: this.order_type,
        sort_order: this.sort_order,
        is_Excel: this.is_export
      };
      if (this.searchParams.type == "00") {
        delete searchParam.type;
      }
      if (!this.time_start || !this.time_end) {
        delete searchParam.start_time;
        delete searchParam.end_time;
      }
      if (this.searchTypeInp != "") {
        searchParam.search_value = this.searchTypeInp;
      }
      this.getlist(searchParam);

      // 发货触发红点更新
      this.$store.dispatch("setUpdataOrderList", false);
      //更新组件
      this.updataPage = new Date().getTime();
    },
    //订单列表排序
    orderSort (a) {
      let sortType;
      let sortOrder = a.order == "descending" ? "desc" : "asc";
      switch (a.prop) {
        case "order_id":
          sortType = 0;
          break;
        case "buy_time":
          sortType = 1;
          break;
        case "product_num":
          sortType = 2;
          break;
        case "orderprice":
          sortType = 3;
          break;
        case "trueprice":
          sortType = 4;
          break;
      }
      this.order_type = sortType;
      this.sort_order = sortOrder;
      this.search();
    },
    //请求数据通用
    getlist (a) {
      this.$store.dispatch("setTableLoading", true);
      this.$axios
        .get("/api/v1/order", {
          params: a
        })
        .then(res => {
          if (res.data.status == "200") {
            this.listData.data = res.data.data;
            this.listData.data.forEach(function (item) {
              item.children = item.child_product;
              item.productname = item.child_product.length > 0 ? item.child_product[0].productname : '';
              // 处理展开子项
              item.child_product.forEach(function (citem, cindex) {
                citem.id = `00${item.id}${cindex}`;
                // citem.order_id = citem.order_id;
                citem.child_product = [];
                citem.order_status = '';
                citem.order_type = item.order_type;
                // citem.productname = citem.productname;
                citem.orderprice = citem.price;
                citem.product_num = citem.number;
                citem.trueprice = item.trueprice;
                citem.type = item.type;
                citem.username = item.username;
                citem.created_at = item.created_at;
                citem.buy_time = item.buy_time;
              })
            })
            // console.log(this.listData.data)

            this.page = res.data.meta;
            this.$store.dispatch("setTableLoading", false);
          } else {
            this.$popup(res.data.msg, "error");
          }
        });
    },
    exportList () {
      let exportParam = {
        type: this.searchParams.type,
        status: this.searchParams.status,
        search_type: this.search_type,
        start_time: this.time_start,
        end_time: this.time_end,
        order_type: this.order_type,
        sort_order: this.sort_order,
        is_Excel: "1"
      };
      if (this.searchParams.type == "00") {
        delete exportParam.type;
      }
      if (!this.time_start || !this.time_end) {
        delete exportParam.start_time;
        delete exportParam.end_time;
      }
      if (this.searchTypeInp != "") {
        exportParam.search_value = this.searchTypeInp;
      }
      this.$axios({
        method: "GET",
        url: "/api/v1/order",
        params: exportParam,
        responseType: "blob"
      }).then(res => {
        let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        let url = URL.createObjectURL(blob);
        window.location.href = url;
      });
    },
    handleSelectionChange () { },
    //table 行的颜色
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "row-white";
      } else if (rowIndex % 2 === 0) {
        return "row-grey";
      }
      return "";
    },
    // 订单状态颜色函数
    getOrderStatusClass (row) {
      // console.log(row)
      if (row.order_status === '交易关闭' || row.order_status === '交易完成') {
        return 'grey'
      } else if (row.order_status === '待收货') {
        return 'blue'
      } else {
        return 'orange'
      }

    }
  },
  components: {
    popAttr,
    popDetail
  }
};
</script>
<style lang="less">
.list-wrap {
  height: calc(100vh - 242px);
  .orderlist-tabs {
    display: inline-block;
    vertical-align: top;
  }
  .orderlist-tabs .el-tabs__header {
    height: 55px;
  }
  .orderlist-tabs .el-tabs__header .el-tabs__active-bar {
    display: none;
  }
  .orderlist-tabs .el-tabs__header .el-tabs__item {
    width: 72px;
    height: 34px;
    padding: 0;
    margin: 0 6px;
    font-size: 12px;
    color: #2e71fe;
    line-height: 34px;
    text-align: center;
    border: 1px solid #2e71fe;
    border-radius: 17px;
    &.is-active {
      color: #ffffff;
      background-color: #2e71fe;
      border: 1px solid #2e71fe;
    }
    span,
    .el-badge {
      width: 100%;
      height: 100%;
      margin-left: 0;
      .el-badge__content.is-fixed {
        top: 0;
      }
    }
  }
  .list-table-wrap .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px;
    height: 10px;
  }
  //滚动条的滑块
  .list-table-wrap .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #c5c5c5;
    border-radius: 3px;
  }
  .list-table-wrap {
    height: 100%;
    .list-table-top {
      height: 82px;
      padding-top: 20px;
      padding-left: 32px;
      font-size: 12px;
      color: #081234;
      background-color: #ffffff;
      .el-dropdown-link {
        color: #081234;
        font-size: 12px;
      }
      .el-button {
        width: 72px;
        height: 34px;
        padding: 0;
        margin: 0 10px;
      }
      .list-table-top-wrap {
        text-align: left;
      }
      .el-input__inner {
        border: none;
        border-radius: 0;
        background-color: #f6f8fb;
      }
      .el-table-state {
        color: #ff6529;
      }
      .el-date-editor .el-range-input {
        background-color: #f6f8fb;
      }
      .el-date-editor .el-range-separator {
        height: 40px;
        line-height: 40px;
        background-color: #ffffff;
      }
      .list-table-top-orderId {
        width: 180px;
        height: 42px;
      }
      .list-table-top-btn-clear {
        // width: 34px;
        height: 34px;
        border: none;
        background-color: transparent;
        color: #2e71fe;
        i {
          position: relative;
          top: 4px;
          font-size: 20px;
          color: #081234;
        }
      }
      .list-table-top-btn-refresh {
        width: 34px;
      }
    }
    .list-table-con {
      position: relative;
      height: calc(100% - 82px);
      .el-table {
        position: relative;
        height: calc(100% - 120px);
        font-size: 12px;
        .el-table__header-wrapper {
          position: absolute;
          top: 0;
        }
        .el-table__body-wrapper {
          position: absolute;
          top: 59px;
          height: calc(100% - 59px);
          overflow-y: scroll;
        }
        .el-badge__content {
          height: 14px;
          line-height: 8px;
          padding: 0 5px;
          background-color: #ff6529;
          cursor: pointer;
        }
        .el-badge__content.is-fixed {
          top: 50%;
          right: 0;
        }
        .el-button.is-focus {
          color: #ffffff;
        }
        .el-button.el-button--default {
          background-color: transparent;
          border: none;
        }
        .table-attr-btn {
          width: 44px;
          height: 24px;
          color: #2e71fe;
        }
        .el-button.el-button--primary {
          width: 44px;
          height: 24px;
          border-radius: 12px;
          border: none;
        }
        .el-icon-caret-top,
        .el-icon-more {
          display: inline-block;
          padding: 6px;
          color: #2e71fe;
          transition: all 0.3s ease;
          cursor: pointer;
          user-select: none;
        }
        .el-icon-caret-top.active {
          transform: rotate(180deg);
        }

        .el-icon-more {
          width: 22px;
          height: 14px;
          padding: 0;
          margin-left: 4px;
          background-color: #ff6529;
          border-radius: 12px;
          font-size: 12px;
          color: #ffffff;
          line-height: 14px;
          cursor: default;
        }
        td.order-table-btns-wrap .cell {
          padding: 0;
          text-align: left;
        }
        // 展开子项的样式
        .el-table__expand-icon {
          display: none;
        }
        .orange {
          color: #ff6529;
        }
        .grey {
          color: #a7a7a7;
        }
        .blue {
          color: #63a9ff;
        }
        // .el-table__row--level-0 +
        .el-table__row--level-1 {
          background: #ebf2ff !important;
          .el-icon-more,
          .el-icon-caret-top,
          .order-table-btns-wrap .el-button,
          .order-table-trueproce-con {
            display: none !important;
          }
        }
        .el-table__expanded-cell {
          .el-form {
            margin-bottom: 20px;
          }
          .el-form-item {
            line-height: 24px;
            margin-bottom: 0;
            padding-left: 70px;
          }
          .el-form-item .el-form-item__label,
          .el-form-item .el-form-item__content {
            line-height: 24px;
          }
          .el-form-item .el-form-item__label {
            color: #081234;
          }
          .el-form-item .el-form-item__content {
            color: #8d8f96;
          }
          .el-image {
            width: 40px;
            height: 40px;
          }
        }
      }
      .el-table .row-white {
        background: #ffffff;
      }
      .el-table .row-grey {
        background: #fafcff;
      }
      .el-table .cell {
        text-align: center;
      }
      .goods-name-td {
        padding: 0 10px;
      }
      .el-pagination {
        // position: absolute;
        // left: 50%;
        bottom: 60px;
        // transform: translateX(-50%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/list/orderlist.vue